module.exports = __webpack_public_path__ + "static/media/observability-background.7865c337.svg";